// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"a052fb24","191":"a4d8955c","226":"cc71859e","311":"4beba95d","376":"dcd7ff37","437":"5e868ec5","488":"856566bb","995":"a39bc048"}[chunkId] + ".chunk.js";
};